import { createClient } from '@supabase/supabase-js'
import type { SetStateAction } from 'react'
import React, { memo, Suspense } from 'react'

import Box from '../../components/Box'
import Spinner from '../../components/Spinner'
import logo from '../../logo.svg'

import Counter from './Counter'
import DocList from './DocList'
import styles from './index.module.css'

interface Props {}

const Index: React.FC<Props> = memo(() => {
  const supabaseUrl = 'https://qdtpgvctsoxnhnbujawg.supabase.co'
  const supabaseKey = 'sb_publishable_zkKWymlWlhICP78YhPxc6A_1pumMc9S'

  const supabase = createClient(supabaseUrl, supabaseKey)

  const [sing, SetSing] = React.useState<SetStateAction<any>>()

  const AddUser = () => {
    supabase
      .from('users')
      .insert([
        {
          name: 'Shrimp',
          age: 28,
          user_id: sing?.user?.id,
        },
      ])
      .then(({ data, error }) => {
        console.log(data, error)
      })
  }

  React.useEffect(() => {
    supabase.auth
      .signInWithPassword({
        email: '1964487389@qq.com',
        password: 'admin123',
      })
      .then(({ data: signInData }) => {
        console.log(signInData)
        SetSing(signInData)
      })
  }, [])

  return (
    <>
      <Box>
        <h1 className={styles.h1} onClick={AddUser}>
          I'm REACT_APP_TEXT from .env
        </h1>
        <img src={logo} alt="react-logo" className="react-logo" />
      </Box>
      <Box>
        <Counter />
      </Box>
      <Box>
        <Suspense fallback={<Spinner size="xl" />}>
          <DocList />
        </Suspense>
      </Box>
    </>
  )
})
Index.displayName = 'Index'

export default Index
